import { render, staticRenderFns } from "./Edited.vue?vue&type=template&id=1ace3baf&scoped=true"
import script from "./Edited.vue?vue&type=script&setup=true&lang=ts"
export * from "./Edited.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Edited.vue?vue&type=style&index=0&id=1ace3baf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ace3baf",
  null
  
)

export default component.exports